import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { Text } from 'foundations-components/components/Text';
import { ONBOARDING_FORECAST_SUBMISSION } from '../../constants/TourConstants';
import { REP_OVERVIEW } from '../../constants/Events';
import { trackCancelUITour, trackFinishUITour } from '../../utils/usageTracker';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingForecastSubmissionTourStep = ({
  children
}) => {
  const {
    tour
  } = useContext(TourContext);
  const isDealStageView = useSelector(getIsDealStageView);
  const handleBeforeNext = useCallback(() => {
    trackFinishUITour(ONBOARDING_FORECAST_SUBMISSION, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const handleCancelTour = useCallback(() => {
    trackCancelUITour(ONBOARDING_FORECAST_SUBMISSION, REP_OVERVIEW, isDealStageView);
  }, [isDealStageView]);
  const tourKey = tour.getTour();
  if (!tourKey) {
    return children;
  }
  return /*#__PURE__*/_jsx(UITourStep, {
    tourKey: tourKey,
    stepKey: ONBOARDING_FORECAST_SUBMISSION,
    showSteps: true,
    placement: "right bottom",
    showCloseButton: true,
    onClickCloseButton: handleCancelTour,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-primary-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.onboarding.forecastSubmission.header"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "tour.onboarding.forecastSubmission.body"
      }),
      footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
        children: /*#__PURE__*/_jsx(UITourNextButton, {
          beforeNext: handleBeforeNext,
          use: "primary",
          size: "small"
        })
      })
    },
    children: children
  });
};
OnboardingForecastSubmissionTourStep.propTypes = {
  children: PropTypes.node.isRequired
};
export default OnboardingForecastSubmissionTourStep;